import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'swiper/css';


function PrivacyPolicy() {
    const [currentIndex, setCurrentIndex] = useState(1)
    const handleFeatursIndex = (index) => setCurrentIndex(index)

    return (
        <>
            <section className='landing_page_main'>
                <section className='cms_page_top_section'>
                    <div className='page_title_section'>
                        <h1>Privacy Policy</h1>
                        <div className='breadcrumb_section'>
                            <ul class="breadcrumb">
                                <li><Link to="/">Home</Link></li>
                                <li> Privacy Policy</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section className='cms_content_section list_li_bold'>
                    <div className='container'>
                        <p><strong>Effective Date: August 23, 2026</strong></p>

                        <p>Budget Your Paycheck LLC (“Budget Your Paycheck,” “BYP,” “we,” “us,” or “our”) respects your privacy. This Privacy Policy explains what information we collect, how we use it, how we share it, and the choices available to you when you use the BYP mobile application and related services.</p>

                        <p>BYP is a paycheck-based budgeting and financial planning tool. BYP does not provide banking, lending, investment, brokerage, tax, fiduciary, or other regulated financial-advisory services.</p>

                        <div className='mt-70'>
                            <h3>1. Information We Collect</h3>

                            <p><strong>Account Information</strong></p>
                            <p>When you create or use a BYP account, we may collect information such as:</p>
                            <ul className='list_about'>
                                <li>Your name</li>
                                <li>Your email address</li>
                                <li>Your password in securely hashed form</li>
                                <li>Account verification information, including one-time verification codes</li>
                                <li>Account status and verification status</li>
                            </ul>
                            <p>BYP currently uses email as the primary account registration and sign-in method.</p>

                            <p><strong>Budgeting Information</strong></p>
                            <p>BYP collects financial and budgeting information that you choose to enter into the app, including information such as:</p>
                            <ul className='list_about'>
                                <li>Income per paycheck</li>
                                <li>Pay frequency and pay-period dates</li>
                                <li>Current savings</li>
                                <li>Savings goals and projections</li>
                                <li>Personal allowance amounts</li>
                                <li>Expense names and categories</li>
                                <li>Expense amounts</li>
                                <li>Expense due dates</li>
                                <li>Expense frequency</li>
                                <li>Planned expense amounts</li>
                                <li>Payment status and related budgeting information</li>
                            </ul>
                            <p>This information is used to provide BYP's paycheck-based budgeting, expense-planning, allowance, and savings features.</p>
                            <p>BYP does not connect to your bank account or collect your online banking credentials as part of the current app experience.</p>

                            <p><strong>Device and Notification Information</strong></p>
                            <p>To operate the app and deliver notifications, we may process information such as:</p>
                            <ul className='list_about'>
                                <li>Device platform or device type</li>
                                <li>Push-notification token</li>
                                <li>Technical request information necessary to operate and secure the service</li>
                            </ul>
                            <p>IP addresses may be processed for security purposes, including rate limiting, abuse prevention, authentication protection, and server operations.</p>
                            <p>BYP does not currently use a dedicated behavioral analytics platform to build advertising or marketing profiles of users.</p>

                            <p><strong>Subscription Information</strong></p>
                            <p>If you purchase BYP+, purchases on iOS are processed through Apple and the App Store.</p>
                            <p>BYP may receive and store information necessary to verify and manage your subscription, including:</p>
                            <ul className='list_about'>
                                <li>Purchase or subscription receipt information</li>
                                <li>Transaction identifiers</li>
                                <li>Subscription start and expiration dates</li>
                                <li>Subscription status</li>
                                <li>Purchase platform</li>
                                <li>Subscription amount or plan information</li>
                            </ul>
                            <p>BYP does not store your full payment-card number, CVV/CVC, or card expiration information.</p>
                            <p>Apple processes your payment credentials according to Apple's own privacy policies and payment practices.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>2. How We Use Your Information</h3>
                            <p>We use information collected through BYP to:</p>
                            <ul className='list_about'>
                                <li>Create and manage your account</li>
                                <li>Verify your identity and account registration</li>
                                <li>Authenticate login attempts</li>
                                <li>Provide paycheck-based budgeting calculations</li>
                                <li>Display and manage income, expenses, savings, planned expenses, and allowances</li>
                                <li>Calculate savings projections and other budgeting information</li>
                                <li>Manage BYP+ subscription access</li>
                                <li>Verify subscription purchases</li>
                                <li>Send account-related, verification, and service communications</li>
                                <li>Deliver push notifications when enabled</li>
                                <li>Provide customer support</li>
                                <li>Maintain, secure, troubleshoot, and improve the operation of the app</li>
                                <li>Detect and prevent fraud, abuse, unauthorized access, and security threats</li>
                                <li>Comply with applicable legal, accounting, and regulatory obligations</li>
                            </ul>
                            <p>BYP's budgeting calculations and guidance are provided for informational and personal budgeting purposes and are not financial, investment, tax, or legal advice.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>3. How We Share Information</h3>
                            <p>We do not sell or rent your personal information.</p>
                            <p>We may share limited information with service providers when necessary to operate BYP.</p>
                            <p>Service providers used in connection with BYP may include:</p>
                            <ul className='list_about'>
                                <li>Apple, for App Store purchases, subscriptions, and purchase verification</li>
                                <li>Google Firebase / Firebase Cloud Messaging, for push-notification functionality</li>
                                <li>SendGrid, for transactional and account-related email delivery</li>
                                <li>Twilio, where applicable for messaging or verification services</li>
                                <li>Hosting, infrastructure, database, and security providers used to operate BYP's backend services</li>
                            </ul>
                            <p>These providers may process only the information necessary to perform their respective services and are subject to their own privacy and security practices.</p>
                            <p>We may also disclose information when reasonably necessary to:</p>
                            <ul className='list_about'>
                                <li>Comply with applicable law, regulation, court order, or legal process</li>
                                <li>Protect the rights, property, security, or safety of Budget Your Paycheck LLC, our users, or others</li>
                                <li>Investigate fraud, abuse, security incidents, or violations of our terms</li>
                                <li>Complete a merger, acquisition, financing, restructuring, or sale of all or part of our business, subject to applicable privacy requirements</li>
                            </ul>
                        </div>

                        <div className='mt-70'>
                            <h3>4. Data Security</h3>
                            <p>We use reasonable administrative, technical, and organizational safeguards designed to protect user information.</p>
                            <p>These safeguards include measures such as:</p>
                            <ul className='list_about'>
                                <li>Encrypted HTTPS/TLS communications</li>
                                <li>Secure authentication controls</li>
                                <li>Protected server and database access</li>
                                <li>Secure storage of authentication tokens on supported mobile devices</li>
                                <li>Access controls and authorization checks</li>
                                <li>Rate limiting and protections against unauthorized login or account access</li>
                            </ul>
                            <p>No electronic system can be guaranteed to be completely secure. You should also protect your account credentials and notify us if you believe your account has been compromised.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>5. Account Deletion and Data Retention</h3>
                            <p>You can initiate account deletion directly from within the BYP app.</p>
                            <p>When an account is deleted, BYP removes or de-identifies personal account information and deletes associated budgeting information, including applicable income, savings, expense, notification, and support records.</p>
                            <p>Authentication information and device-related account identifiers are also removed or invalidated.</p>
                            <p>Certain limited subscription transaction records may be retained when reasonably necessary for payment records, accounting, audit, fraud prevention, legal compliance, or dispute-resolution purposes.</p>
                            <p>Retained records are not used to restore a deleted user's personal budgeting profile.</p>
                            <p>If you need assistance with account deletion, you may contact us at info@bypapp.com.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>6. Your Choices</h3>
                            <p>Depending on the feature, you may:</p>
                            <ul className='list_about'>
                                <li>Update certain account information within the app</li>
                                <li>Add, edit, or delete budgeting information</li>
                                <li>Control notification permissions through your device settings</li>
                                <li>Cancel or manage an Apple subscription through your App Store account settings</li>
                                <li>Delete your BYP account through the app</li>
                                <li>Contact us with privacy-related questions or requests</li>
                            </ul>
                        </div>

                        <div className='mt-70'>
                            <h3>7. Third-Party Services and Links</h3>
                            <p>BYP may interact with or provide links to third-party services.</p>
                            <p>Third-party services have their own privacy policies and practices. Budget Your Paycheck LLC is not responsible for the privacy practices of third parties that operate independently from BYP.</p>
                            <p>We encourage you to review the privacy policies of services you choose to use.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>8. Children's Privacy</h3>
                            <p>BYP is not intended to be used by children in violation of applicable privacy laws.</p>
                            <p>We do not knowingly seek to collect personal information from children where parental consent or other authorization would be legally required.</p>
                            <p>If you believe a child has provided personal information to BYP in violation of applicable law, please contact us at info@bypapp.com.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>9. Changes to This Privacy Policy</h3>
                            <p>We may update this Privacy Policy from time to time to reflect changes to BYP, our practices, legal requirements, or third-party services.</p>
                            <p>When we make material changes, we may update the Effective Date above and provide additional notice where appropriate.</p>
                            <p>Your continued use of BYP after an updated Privacy Policy becomes effective is subject to the updated policy.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>10. Contact Us</h3>
                            <p>If you have questions, concerns, or requests regarding this Privacy Policy or BYP's privacy practices, contact:</p>
                            <p>Budget Your Paycheck LLC<br />Email: info@bypapp.com</p>
                        </div>
                    </div>
                </section>

                <section id='download-app' className='download_app_section section'>
                    <div className='container'>
                        <div className='download_section'>
                            <div className='download_box'>
                                <h2 className='font-52'>Download from the Apple & Google Play Store</h2>
                                <p className='font-20'>Ready to manage your money between paychecks? Download BYP now from the App Store or Google Play! Whether you’re an iOS or Android user, your journey to financial freedom is just a click away.
                                </p>
                                <div className='download_button_play'>
                                    <a className='app_store_btn' href='https://apps.apple.com/app/id6738954470' target='_blank' rel='noopener noreferrer'><img src="/images/app_store.svg" alt="Download on the App Store" /></a>
<a className='app_store_btn' href='https://play.google.com/store/apps/details?id=com.budget_bible.android&pcampaignid=web_share' target='_blank' rel='noopener noreferrer'><img src="/images/google_play.svg" alt="Get it on Google Play" /></a>
                                </div>
                            </div>
                            <div className='download_box_tow'>
                                <div className='image_left_download'>
                                    <img src="/images/byp-download-app-mockup.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="contact-us" className="contact_section section">
                    <div className='container'>
                        <div className='contact_content'>
                            <h2 className='font-52'>Contact Us</h2>
                            <p className='font-20'>Have Questions? We’re Here to Help!</p>

                            <div className='contact_form'>
                                <div className='row g-5'>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='First Name' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Last Name' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Email Address' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Phone Number' />
                                    </div>
                                    <div className='col-12'>
                                        <textarea id="txtid" name="txtname" rows="4" cols="50" maxlength="200" className='contact_input text_area' placeholder='Write a message'></textarea>
                                    </div>
                                    <div className='col-12'>
                                        <button type='button' className='btn submit_btn'>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default PrivacyPolicy;
